
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { User } from '@supabase/supabase-js';

interface TripDetails {
  id: string;
  name: string;
  destination: string;
}

export const useTripInvite = (inviteCode: string | null, user: User | null, authLoading: boolean) => {
  const [isLoading, setIsLoading] = useState(true);
  const [tripDetails, setTripDetails] = useState<TripDetails | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [joined, setJoined] = useState(false);

  useEffect(() => {
    const fetchTripDetails = async () => {
      if (!inviteCode) {
        setError('No invitation code provided');
        setIsLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from('trips')
          .select('id, name, destination')
          .eq('invite_code', inviteCode)
          .single();

        if (error) {
          console.error('Error fetching trip:', error);
          setError('Invalid invitation link');
        } else if (data) {
          setTripDetails(data);
          
          // If user is logged in, check if already a member
          if (user) {
            const { data: memberData } = await supabase
              .from('trip_members')
              .select('id')
              .eq('trip_id', data.id)
              .eq('user_id', user.id)
              .maybeSingle();
              
            setJoined(!!memberData);
          }
        }
      } catch (error) {
        console.error('Error:', error);
        setError('Something went wrong');
      } finally {
        setIsLoading(false);
      }
    };

    if (!authLoading) {
      fetchTripDetails();
    }
  }, [inviteCode, user, authLoading]);

  return {
    isLoading,
    tripDetails,
    error,
    joined,
    setJoined
  };
};
